



























































































import { Component, Vue, Prop, Model, Emit } from "vue-property-decorator";
import { Ruta } from "@/typings/store/modules/rutas";
import SVGIcon from "@/components/SVGIcon.vue";
import { mapGetters } from "vuex";

const iconContext = require.context("@/assets/icons", false, /\.svg$/);

/** Iconos MDI acordes a cada módulo (cuando no hay SVG propio o como referencia) */
const ICONOS_POR_MODULO: Record<string, string> = {
  prenominas: "mdi-account-cash",
  visualizacionPagos: "mdi-chart-areaspline",
  registrosEgresos: "mdi-bank-transfer",
  ordenes: "mdi-clipboard-list-outline",
  usuarios: "mdi-account-group",
  perfil: "mdi-account-circle",
  proveedores: "mdi-truck-delivery-outline",
  tipoDocumentos: "mdi-file-document-multiple-outline",
  tipoCargos: "mdi-tag-multiple-outline",
  bancos: "mdi-bank",
  centrosCostos: "mdi-domain",
  codCuentas: "mdi-numeric",
  cajaChicas: "mdi-cash-multiple",
  cajaChicasLinares: "mdi-cash-multiple",
  cajaChicasTalca: "mdi-cash-multiple",
  cajaChicasTalcaGerencial: "mdi-cash-multiple",
  cajaChicasSantiagoVV: "mdi-cash-multiple",
  cajaChicasSantiagoOF: "mdi-cash-multiple",
  mapeoGastos: "mdi-chart-box-outline",
  condicionesComerciales: "mdi-handshake-outline",
  condicionesDivisiones: "mdi-vector-difference",
  facturas: "mdi-receipt-text",
  locales: "mdi-storefront",
  contratos: "mdi-file-sign",
  clientes: "mdi-account-tie",
  notasCredito: "mdi-note-text-outline",
};

@Component({
  computed: mapGetters({
    getRutas: "rutas/get",
    getRutasUsuario: "usuario/getRutas",
  }),
  components: { SVGIcon },
})
export default class Principal extends Vue {
  @Model("input", { type: Boolean }) readonly value!: boolean;
  @Prop() readonly items!: Array<Ruta>;

  @Emit("input")
  onInput(value: boolean): boolean {
    return value;
  }

  get getRutasArray(): Array<Ruta> {
    return this.getRutas ? Object.values(this.getRutas) : [];
  }

  get rutasUsuario(): Array<Ruta> {
    return this.getRutasUsuario || [];
  }

  /** Módulos visibles en el menú (con show true) */
  get modulosVisibles(): Array<Ruta> {
    return this.rutasUsuario.filter((r) => r.show !== false);
  }

  to(ruta: Ruta): void {
    if (ruta.to && this.$route.name !== ruta.to?.name) {
      this.$router.push(ruta.to);
    }
  }

  /** Devuelve el icono MDI a usar: el del ítem si es mdi, o el mapeado al módulo */
  iconoMdi(item: Ruta): string {
    if (item.icon && String(item.icon).includes("mdi")) return item.icon;
    return ICONOS_POR_MODULO[item.id] || "mdi-view-module";
  }

  /** Ruta al SVG del módulo si existe en assets/icons */
  iconSrc(iconName: string): string {
    if (!iconName || String(iconName).includes("mdi")) return "";
    const key = iconContext.keys().find((k: string) => k === "./" + iconName + ".svg");
    return key ? iconContext(key) : "";
  }

  get actualRute(): string {
    return this.$route.name ?? "";
  }
}
